import { serverGet, serverPost } from "lib/serverRequest";

export const getPies = ({ onFinish = () => {} }) => {
  serverGet({ url: `pie`, onFinish: onFinish });
};

export const createPie = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `pie/create`,
    data: {
      name: data?.name ?? "",
      description: data?.description ?? "",
      price: data?.price ?? 0,
      price_oneoff: data?.price_oneoff ?? 0,
      image: data?.image ?? "",
      images: data?.images ?? [],
    },
    onFinish: onFinish,
  });
};

export const updatePie = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `pie/update`,
    data: {
      id: data?.id ?? 0,
      name: data?.name ?? "",
      description: data?.description ?? "",
      price: data?.price ?? 0,
      price_oneoff: data?.price_oneoff ?? 0,
      image: data?.image ?? "",
      images: data?.images ?? [],
    },
    onFinish: onFinish,
  });
};
